module.exports = __webpack_public_path__ + "static/media/cattle-drones-thumbnail.a14400bb.jpg";